module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.2abef08d.woff";